import createPersistedState from 'vuex-persistedstate'

export default ({ store }) => {
  createPersistedState({
    paths: ['devise', 'auth', 'announcement'] // localStorageに保存したいstoreを入れる
  })(store)
}
